
import hasPermi from './hasPermi'

const install = function(Vue) {

  Vue.directive('hasPermi', hasPermi.inserted)
}

if (window.Vue) {
  window['hasPermi'] = hasPermi.inserted
  Vue.use(install); // eslint-disable-line
}

export default install
